// extracted by mini-css-extract-plugin
module.exports = {"app":"index_app__3GiEB","container":"index_container__sJ51s","contentBox":"index_contentBox__3VCZz","full":"index_full__3bLLB"};